<template>
  <!-- D: 모달은 .l-wrap 바깥에 넣어주세요. -->
  <!-- D: 퍼블에서는 hidden 클래스넣지만 개발에서는 동적으로 불러와야할 듯합니다 -->
  <AbstractPop :type-mo-full="true" :is-quick-attached="true">
    <template v-slot>
      <div class="dialog type-large type-non-footer">
        <header class="dialog-header">
          <h2 class="dialog-title only-pc">동영상 가이드</h2>
          <button
            type="button"
            class="dialog-close"
            @click="() => emits('close')"
          >
            <span class="c-icon icon-large-x"></span>
            <span class="sr-only">팝업 닫기</span>
          </button>
        </header>

        <div class="dialog-content">
          <div class="dialog-content-inner">
            <!-- D: MO에서만 존재 -->
            <h3 class="c-title-level3 only-mo">동영상 가이드</h3>

            <div class="m-video-guide">
              <h4 class="c-title-level4">{{ selectedManual.manualTitleNm }}</h4>
              <div class="video-main">
                <!-- D: video sample -->
                <iframe
                  :src="vimeoUrl"
                  frameborder="0"
                  webkitallowfullscreen
                  mozallowfullscreen
                  allowfullscreen
                ></iframe>
              </div>

              <div class="video-list" v-if="props.manuals.length > 1">
                <ul>
                  <ThumbRow
                    v-for="(manual, index) in props.manuals"
                    :key="manual.manualSn"
                    :manual="manual"
                    :index="index"
                    @selected="
                      (index) => (selectedManual = props.manuals[index])
                    "
                  />
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- D: dimmed -->
      <div class="dimmed"></div>
    </template>
  </AbstractPop>
</template>
<script setup name="videoGuidePop">
import { defineEmits, defineProps, ref, computed } from "vue";
import ThumbRow from "./videoGuidePopThumbRow";
import AbstractPop from "@/components/paintpro/common/AbstractPop.vue";

const emits = defineEmits(["close"]);

const props = defineProps({
  manuals: {
    type: Array,
    required: true,
  },
});

const selectedManual = ref(props.manuals[0]);

const vimeoUrl = computed(() => {
  const regx = /vimeo\.com\/(\d+)/;

  const match = selectedManual.value.videoUrl.match(regx);
  const videoId = match[1];

  return `https://player.vimeo.com/video/${videoId}`;
});
</script>
<style scoped></style>
